import { z } from '@harvestiq/zod';
import {
  dbSigningAgentInsertSchema,
  dbSigningAgentSchema,
} from './db-signing-agent';

export const createSigningAgentRequestBodySchema = dbSigningAgentInsertSchema;

export type CreateSigningAgentRequestBody = z.infer<
  typeof createSigningAgentRequestBodySchema
>;

export const createSigningAgentSuccessResponseSchema = z.object({
  data: dbSigningAgentSchema,
});

export type CreateSigningAgentSuccessResponse = z.infer<
  typeof createSigningAgentSuccessResponseSchema
>;

export const createSigningAgentErrorResponseSchema = z.object({
  errors: z.array(
    z.object({
      message: z.string(),
      key: z.string().optional(),
      source: z.string().optional(),
    })
  ),
});

export type CreateSigningAgentErrorResponse = z.infer<
  typeof createSigningAgentErrorResponseSchema
>;

export const createSigningAgentResponseSchema =
  createSigningAgentSuccessResponseSchema.or(
    createSigningAgentErrorResponseSchema
  );

export type CreateSigningAgentResponse = z.infer<
  typeof createSigningAgentResponseSchema
>;
